export default __webpack_public_path__ + "static/media/cancelar_ciculo.84c0744e.svg";